module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "f-share"
  }, [_c('transition', {
    attrs: {
      "name": "slideInUp"
    },
    on: {
      "after-leave": _vm.slideInUpLeave
    }
  }, [(_vm.showContent) ? _c('div', {
    staticClass: "share-content"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("分享到")]), _vm._v(" "), _c('div', {
    staticClass: "share-list-wrap"
  }, [_c('div', {
    staticClass: "share-list"
  }, [_vm._l((_vm.shareItem), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "share-wrap",
      attrs: {
        "data-type": item.type
      },
      on: {
        "click": _vm.onShareHandle
      }
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": item.text
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])])
  }), _vm._v(" "), _vm._l((4 - _vm.shareItem.length), function(i) {
    return _c('div', {
      key: i,
      staticClass: "share-wrap"
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "share-cancle",
    class: {
      'iPhoneX': _vm.isiPhoneX
    },
    on: {
      "click": _vm.onCancleHandle
    }
  }, [_vm._v("取消")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "share-mask",
    on: {
      "click": _vm.onCancleHandle
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-249dde2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-249dde2a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/share/share.vue
// module id = 26
// module chunks = 0